import { Component, Input } from '@angular/core';
import { IExpert } from '@techspert-io/experts';
import { IOpportunity } from '@techspert-io/opportunities';

@Component({
  selector: 'app-opportunity-actions-menu',
  templateUrl: './opportunity-actions-menu.component.html',
  styleUrls: ['./opportunity-actions-menu.component.scss'],
  standalone: false,
})
export class OpportunityActionsMenuComponent {
  @Input() experts: IExpert[];
  @Input() opportunity: IOpportunity;

  moreActionsToggle = false;

  toggleMoreActionsMenu(): void {
    this.moreActionsToggle = !this.moreActionsToggle;
  }

  closeMoreActionsMenu(): void {
    this.moreActionsToggle = false;
  }
}
